import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "title-row" }
const _hoisted_4 = { class: "title-controls" }
const _hoisted_5 = { class: "default-count" }
const _hoisted_6 = { class: "filters" }
const _hoisted_7 = { class: "dropdown-button" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "spinner"
}
const _hoisted_10 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "table-wrapper table-wrapper--users scroll-wrapper"
}
const _hoisted_13 = { class: "table-default" }
const _hoisted_14 = { class: "bold" }
const _hoisted_15 = { class: "text-highlighted" }
const _hoisted_16 = {
  key: 0,
  class: "dropdown-projects"
}
const _hoisted_17 = { class: "dropdown-button" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "menu-wrapper" }
const _hoisted_24 = { class: "wrapper-dots" }
const _hoisted_25 = { class: "menu-option" }
const _hoisted_26 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title-main" }, "Users", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "button default primary",
              to: { name: 'LandownerUsersCreate' }
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Add new user", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString($setup.plural($setup.users.length, "User")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode($setup["DropDown"], null, {
          control: _withCtx(() => [
            _createElementVNode("button", _hoisted_7, "Project is " + _toDisplayString($setup.activeFilter?.title ? $setup.activeFilter?.title : "Any"), 1)
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeFilter({ title: 'Any' })))
              }, "Any"),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.estates, (item, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  onClick: ($event: any) => ($setup.changeFilter(item)),
                  class: _normalizeClass({ 'dropdown__item-active': $setup.activeFilter?.title === item?.title })
                }, _toDisplayString(item?.title), 11, _hoisted_8))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode($setup["InputSearch"], {
          class: "search",
          modelValue: $setup.searchQuery,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchQuery) = $event)),
          placeholder: "Search",
          theme: "filter"
        }, null, 8, ["modelValue"])
      ]),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
        : ($setup.users.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("img", {
                class: "empty-block--icon",
                src: require('@/assets/icons/icon-sales-person-slim.svg')
              }, null, 8, _hoisted_11),
              _cache[6] || (_cache[6] = _createElementVNode("p", null, "You have no users yet", -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("table", _hoisted_13, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.titles, (item, index) => {
                      return _createElementVNode("th", { key: index }, _toDisplayString(item), 1)
                    }), 64)),
                    _cache[7] || (_cache[7] = _createElementVNode("th", null, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.users, (row, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(row?.firstName) + " " + _toDisplayString(row?.lastName), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(row?.email), 1),
                      _createElementVNode("td", null, _toDisplayString(row?.phone), 1),
                      (row.details.estates.length > 1)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                            _createVNode($setup["DropDown"], { placement: 'width-by-content' }, _createSlots({
                              control: _withCtx(() => [
                                _createElementVNode("button", _hoisted_17, [
                                  _createElementVNode("span", null, _toDisplayString(row.details.estates.length) + " Projects", 1)
                                ])
                              ]),
                              _: 2
                            }, [
                              (row.details.estates.length)
                                ? {
                                    name: "dropdown",
                                    fn: _withCtx(() => [
                                      _createElementVNode("ul", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.details.estates, (item) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: item._id
                                          }, _toDisplayString(item.title), 1))
                                        }), 128))
                                      ])
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1024)
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(row.details?.estates[0]?.title || "-"), 1)),
                      _createElementVNode("td", null, [
                        (row?.verifiedEmail)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("div", { class: "badge success" }, "Active", -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["button primary default", { 'resend-btn': row.details.isInvited }]),
                                onClick: ($event: any) => ($setup.sendInvite(row._id, row.email))
                              }, [
                                _createTextVNode(_toDisplayString(row.details.isInvited ? "Resend invite" : "Send Invite"), 1),
                                (row.details.isInvited)
                                  ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: require('@/assets/icons/icon-info.svg')
                                    }, null, 8, _hoisted_22)), [
                                      [_directive_tippy, { content: $setup.tooltipText, theme: 'light-border', placement: 'top' }]
                                    ])
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_21)
                            ]))
                      ]),
                      _createElementVNode("td", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode($setup["DropDown"], { placement: 'right top' }, {
                            control: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("div", { class: "dots" }, [
                                _createElementVNode("div", { class: "actions" })
                              ], -1)
                            ]))]),
                            dropdown: _withCtx(() => [
                              _createElementVNode("ul", _hoisted_25, [
                                _createElementVNode("li", null, [
                                  _createVNode(_component_router_link, {
                                    class: "menu-item edit",
                                    to: { name: 'LandownerUsersEdit', params: { salesPersonId: row._id } }
                                  }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createTextVNode("Edit", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"])
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("div", {
                                    class: "menu-item delete",
                                    onClick: ($event: any) => (($setup.showConfirmDeleteModal = true), ($setup.salesPersonForDelete = row))
                                  }, "Delete", 8, _hoisted_26)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
    ]),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.showConfirmDeleteModal,
      deleteItem: $setup.salesPersonFullNameForDelete,
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => ($setup.deleteSalesPerson())),
      onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.showConfirmDeleteModal = false))
    }, null, 8, ["isOpen", "deleteItem"])
  ], 64))
}